import React from 'react'
import { string, number } from 'prop-types'
import { css } from '@emotion/react'

const linkCss = css`
  > a {
    &:hover {
      text-decoration: underline;
    }
  }
`

const Link = ({ url, label, index, linksLength }) => {
  const isLastElement = linksLength !== undefined && index === linksLength - 1

  return (
    <span css={linkCss}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
      {isLastElement ? '.' : <span>,&nbsp;</span>}
    </span>
  )
}

Link.propTypes = {
  url: string,
  label: string,
  index: number,
  linksLength: number,
}

export default Link
